module.exports = __webpack_public_path__ + "static/images/bg_myPC.cb5ce2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/bg_myPC.svg
// module id = 1271
// module chunks = 0